import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "p-8 text-center" };
import { RestaurantLayout } from '@shared';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotFoundPage',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createBlock(_unref(RestaurantLayout), null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-6xl font-bold text-red-600 mb-8" }, "404", -1 /* CACHED */)),
                        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-3xl font-bold mb-4" }, "Seite nicht gefunden", -1 /* CACHED */)),
                        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xl text-gray-600 mb-8" }, " Die gesuchte Seite existiert nicht. ", -1 /* CACHED */)),
                        _createVNode(_component_router_link, {
                            to: "/",
                            class: "bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 inline-block"
                        }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createTextVNode(" Zur Startseite ", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
